import { startOfMonth, endOfMonth } from 'date-fns';
import httpClient from '../utils/httpClient';

export const getCctvList = async (county) => {
  try {
    const response = await httpClient.get('/cctv/list');
    return response.data.filter((a) => a.county === county);
  } catch (error) {
    console.error('Error fetching CCTV data:', error);
    throw error;
  }
};

export const getCctvListNewTaipei2 = async () => {
  try {
    const response = await httpClient.get('/cctv/newtaipei2/list');
    return response.data;
  } catch (error) {
    console.error('Error fetching newtaipei2 CCTV data:', error);
    throw error;
  }
};
export const getCctvImages = async (
  cctvCode,
  page,
  limit = 10,
  selectedDate = new Date(),
  teamName
) => {
  try {
    const startDate = startOfMonth(selectedDate);
    const endDate = endOfMonth(selectedDate);
    const response = await httpClient.get(`/cctv/images/${cctvCode}`, {
      params: {
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        page,
        limit,
        teamName
      }
    });
    console.log('CCTV images cctv/images:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching CCTV images:', error);
    throw error;
  }
};
export const getDailyEventAggregation = async (date, teamName) => {
  try {
    const url = `/cctv/daily-aggregation/${date}`;
    const params = { teamName };
    const response = await httpClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily event aggregation:', error);
    throw error;
  }
};

export const getDailyEventAggregationNewTaipei2 = async (date) => {
  try {
    const response = await httpClient.get(`/cctv/newtaipei2/daily-aggregation/${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching newtaipei2 daily aggregation:', error);
    throw error;
  }
};

export const getMonthlyEventAggregation = async (camera, month) => {
  try {
    const response = await httpClient.post(`/cctv/monthly-aggregation/${camera}/${month}`);
    console.log('Monthly event aggregation:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching monthly event aggregation:', error);
    throw error;
  }
};

export const getMonthlyHourEventAggregation = async (camera, month) => {
  try {
    const response = await httpClient.get(
      `/cctv/monthly-hourly-aggregation/${camera}/${month}?format=csv`
    );
    if (!response.data.ok) {
      throw new Error('API 請求失敗');
    }
    console.log('Monthly event aggregation:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching monthly event aggregation:', error);
    throw error;
  }
};

/**
 * 取得指定日期、指定攝影機每小時各 object_type 偵測次數
 * @param {string} date - 'YYYY-MM-DD'
 * @param {string} camera - camera_code (e.g. 'cam9')
 * @param {string} teamName - region (e.g. 'tainan')
 */
export const getDailyDetectionByType = async (date, camera, teamName) => {
  try {
    const response = await httpClient.get(`/cctv/detection/hourly-by-type/${date}`, {
      params: { camera, teamName }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily detection by type:', error);
    throw error;
  }
};

/**
 * 取得指定月份、指定攝影機每日各 object_type 偵測次數 (CSV 下載用)
 * @param {string} camera - camera_code
 * @param {string} month - 'YYYY-MM'
 * @param {string} teamName - region
 */
export const getMonthlyDetectionByType = async (camera, month, teamName) => {
  try {
    const response = await httpClient.get(
      `/cctv/detection/monthly-by-type/${camera}/${month}`,
      { params: { teamName, format: 'csv' } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching monthly detection by type:', error);
    throw error;
  }
};

/**
 * 新北2 歷史月報 — 查詢 detection_photos
 * @param {string} camera - e.g. "cam9"
 * @param {string} month  - YYYY-MM
 */
export const getHistoryMonthlyDetectionStats = async (camera, month) => {
  try {
    const response = await httpClient.get(
      `/cctv/newtaipei2/history/monthly/${camera}/${month}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching newtaipei2 history monthly stats:', error);
    throw error;
  }
};
